export const OrdinalNumbers = ['First', 'Second', 'Third', 'Fourth', 'Fifth'];
// The Ordinal Text values are limited to the 5th level,
// so we are setting this limit to 5.
export const MaxAdditional = 5;
